import React, { useState, useRef, useEffect } from 'react';
import LazyImage from './components/LazyImage';

export const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:wght@400;500&family=Montserrat:wght@300;400&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  body {
    font-family: 'Apple Garamond', Garamond, 'Times New Roman', serif;
    background: #e6c57e;
    background-image: repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(49,35,16,.02) 2px, rgba(49,35,16,.02) 4px);
  }

  @keyframes fadeSlideIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes expandLine {
    from {
      opacity: 0;
      width: 0;
    }
    to {
      opacity: 1;
      width: 60px;
    }
  }

  @keyframes itemFadeIn {
    to {
      opacity: 1;
    }
  }

  @keyframes lightboxZoom {
    from {
      transform: scale(0.9);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  .gallery {
    columns: 4;
    column-gap: 8px;
  }

  @media (max-width: 1400px) {
    .gallery {
      columns: 3;
    }
  }

  @media (max-width: 900px) {
    .gallery {
      columns: 2;
    }
  }

  @media (max-width: 600px) {
    .gallery {
      columns: 2;
      column-gap: 8px;
    }
  }

  .gallery-item {
    position: relative;
    overflow: hidden;
    opacity: 0;
    animation: itemFadeIn 0.8s ease forwards;
    cursor: pointer;
    break-inside: avoid;
    margin-bottom: 4px;
    display: inline-block;
    width: 100%;
  }

  .image-wrapper {
    position: relative;
    overflow: hidden;
    background: #aeb4b8;
    border: 1px solid rgba(49,35,16,0.15);
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    display: block;
    width: 100%;
  }

  .image-wrapper::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(198,162,91,0) 0%, rgba(198,162,91,0.15) 100%);
    opacity: 0;
    transition: opacity 0.5s ease;
    z-index: 1;
    pointer-events: none;
  }

  .gallery-item:active .image-wrapper {
    border-color: #af731f;
    box-shadow: 
      0 8px 30px rgba(49,35,16,0.18),
      0 0 30px rgba(175,115,31,0.25),
      inset 0 0 30px rgba(175,115,31,0.08);
    transform: translateY(-4px);
  }

  .gallery-item:active .image-wrapper::before {
    opacity: 1;
  }

  .gallery-item img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    filter: saturate(0.92) contrast(1.08);
  }

  .gallery-item:active img {
    transform: scale(1.05);
  }

  .delete-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(49,35,16,0.8);
    color: #e6c57e;
    border: none;
    min-width: 44px;
    min-height: 44px;
    border-radius: 50%;
    cursor: pointer;
    opacity: 1;
    transition: all 0.3s ease;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 300;
    -webkit-tap-highlight-color: transparent;
  }

  .delete-button:active {
    background: #af731f;
    color: #312310;
    transform: scale(1.1);
  }
`;

// ==================== COMPONENTS ====================

// ==================== TOAST NOTIFICATION ====================

// export const styles = `
//   @import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:wght@400;500&family=Montserrat:wght@400;500;600&display=swap');

//   :root {
//     --glass-bg: rgba(255, 255, 255, 0.15);
//     --glass-border: rgba(255, 255, 255, 0.2);
//     --glass-shadow: 0 8px 32px 0 rgba(49, 35, 16, 0.15);
//     --ios-easing: cubic-bezier(0.25, 1, 0.5, 1); /* Apple-style spring */
//     --accent-gold: #e6c57e;
//     --accent-brown: #312310;
//   }

//   * {
//     margin: 0;
//     padding: 0;
//     box-sizing: border-box;
//     -webkit-tap-highlight-color: transparent; /* Crucial for iOS feel */
//   }

//   body {
//     font-family: 'Apple Garamond', 'Bodoni Moda', serif;
//     background: #e6c57e;
//     /* Smoother, subtler texture */
//     background-image: radial-gradient(circle at center, transparent 0%, rgba(49,35,16,0.03) 100%);
//     overscroll-behavior-y: none; /* Prevents bounce scrolling on body */
//   }

//   /* --- iOS GLASS UTILITIES --- */
//   .ios-glass {
//     background: rgba(240, 230, 210, 0.25);
//     backdrop-filter: blur(20px);
//     -webkit-backdrop-filter: blur(20px); /* Safari support */
//     border: 1px solid rgba(255, 255, 255, 0.3);
//     box-shadow: var(--glass-shadow);
//   }

//   .ios-glass-dark {
//     background: rgba(30, 20, 10, 0.65);
//     backdrop-filter: blur(25px);
//     -webkit-backdrop-filter: blur(25px);
//     border: 1px solid rgba(255, 255, 255, 0.1);
//   }

//   .ios-btn {
//     transform: scale(1);
//     transition: transform 0.2s var(--ios-easing), background 0.2s ease;
//     will-change: transform; /* Performance hint */
//   }

//   .ios-btn:active {
//     transform: scale(0.94); /* The "Button Press" feel */
//   }

//   /* --- GALLERY LAYOUT --- */
//   .gallery {
//     columns: 2; /* Default to 2 on mobile for bigger, clearer images */
//     column-gap: 16px;
//     padding: 16px;
//   }

//   @media (min-width: 768px) { .gallery { columns: 3; } }
//   @media (min-width: 1200px) { .gallery { columns: 4; } }

//   .gallery-item {
//     break-inside: avoid;
//     margin-bottom: 16px;
//     position: relative;
//     opacity: 0;
//     animation: itemFadeIn 0.6s ease forwards;
//   }

//   /* The "Bubble" Image Wrapper */
//   .image-wrapper {
//     position: relative;
//     border-radius: 24px; /* iOS rounded corners */
//     overflow: hidden;
//     background: rgba(49,35,16,0.05);
//     /* Remove borders, use shadow for depth */
//     box-shadow: 0 4px 15px rgba(49,35,16,0.08);
//     transition: transform 0.4s var(--ios-easing), box-shadow 0.4s ease;
//     will-change: transform;
//   }

//   .gallery-item:active .image-wrapper {
//     transform: scale(0.98);
//     box-shadow: 0 2px 8px rgba(49,35,16,0.05);
//   }

//   .gallery-item img {
//     width: 100%;
//     height: auto;
//     display: block;
//     /* Subtle cinematic filter */
//     filter: brightness(1.02) contrast(1.05);
//     transition: transform 0.8s ease;
//   }

//   /* --- MODAL ANIMATIONS (Sheet Slide Up) --- */
//   @keyframes slideUpSheet {
//     from { transform: translateY(100%); opacity: 0; }
//     to { transform: translateY(0); opacity: 1; }
//   }

//   @keyframes scaleInFade {
//     from { transform: scale(0.95); opacity: 0; }
//     to { transform: scale(1); opacity: 1; }
//   }
  
//   @keyframes itemFadeIn { to { opacity: 1; } }
// `;



let toastTimeout = null;
export const showToast = (message) => {
  // Remove existing toast if any
  const existingToast = document.getElementById('toast-notification');
  if (existingToast) {
    existingToast.remove();
  }
  if (toastTimeout) {
    clearTimeout(toastTimeout);
  }

  // Create toast element
  const toast = document.createElement('div');
  toast.id = 'toast-notification';
  toast.style.cssText = `
    position: fixed;
    bottom: calc(30px + env(safe-area-inset-bottom));
    left: 50%;
    transform: translateX(-50%);
    background: rgba(49,35,16,0.95);
    color: #e6c57e;
    padding: 16px 24px;
    border-radius: 8px;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    letter-spacing: 0.05em;
    z-index: 100000;
    box-shadow: 0 4px 20px rgba(49,35,16,0.4);
    animation: toastSlideUp 0.3s ease;
    max-width: calc(100vw - 60px);
    word-wrap: break-word;
    text-align: center;
  `;
  toast.textContent = message;
  document.body.appendChild(toast);

  // Add animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes toastSlideUp {
      from {
        opacity: 0;
        transform: translateX(-50%) translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
    }
  `;
  if (!document.getElementById('toast-styles')) {
    style.id = 'toast-styles';
    document.head.appendChild(style);
  }

  // Remove after 3 seconds
  toastTimeout = setTimeout(() => {
    toast.style.animation = 'toastSlideUp 0.3s ease reverse';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.remove();
      }
    }, 300);
  }, 3000);
};

// Report Image Modal Component
export const ReportImageModal = ({ photo, onClose, onReport, currentUserId }) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    if (photo) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [photo]);

  if (!photo) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedReason) {
      alert('Please select a reason for reporting');
      return;
    }

    setSubmitting(true);
    try {
      // Report type is 'photo' - we're reporting a specific image
      await onReport(photo.id, currentUserId, photo.user_id, selectedReason);
      alert('Report submitted successfully');
      onClose();
    } catch (error) {
      console.error('Report failed:', error);
      alert('Failed to submit report. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const reasons = [
    { value: 'nudity', label: 'Nudity or sexual content' },
    { value: 'hate', label: 'Hate speech or symbols' },
    { value: 'violence', label: 'Violence or harm' },
    { value: 'spam', label: 'Spam or scam' },
    { value: 'other', label: 'Other' }
  ];

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(49,35,16,0.7)',
        zIndex: 10002,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        paddingTop: 'calc(20px + env(safe-area-inset-top))',
        paddingBottom: 'calc(20px + env(safe-area-inset-bottom))',
        paddingLeft: 'calc(20px + env(safe-area-inset-left))',
        paddingRight: 'calc(20px + env(safe-area-inset-right))'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: '#aeb4b8',
          padding: '40px',
          maxWidth: '500px',
          width: '100%',
          border: '1px solid rgba(130,85,30,0.2)',
          boxShadow: '0 8px 30px rgba(49,35,16,0.2)',
          borderRadius: '8px',
          boxSizing: 'border-box'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{
          fontFamily: "'Apple Garamond', Garamond, 'Times New Roman', serif",
          fontSize: '1.8em',
          color: '#312310',
          letterSpacing: '0.08em',
          fontWeight: 400,
          marginBottom: '24px',
          textAlign: 'center'
        }}>
          Report Image
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '24px' }}>
            {reasons.map((reason) => (
              <label
                key={reason.value}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px',
                  marginBottom: '8px',
                  cursor: 'pointer',
                  borderRadius: '4px',
                  transition: 'background 0.2s ease',
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '14px',
                  color: '#312310'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(130,85,30,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                <input
                  type="radio"
                  name="reportReason"
                  value={reason.value}
                  checked={selectedReason === reason.value}
                  onChange={(e) => setSelectedReason(e.target.value)}
                  style={{
                    marginRight: '12px',
                    width: '18px',
                    height: '18px',
                    cursor: 'pointer',
                    accentColor: '#af731f'
                  }}
                />
                {reason.label}
              </label>
            ))}
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              style={{
                flex: 1,
                padding: '10px 24px',
                background: '#553918',
                color: '#e6c57e',
                border: 'none',
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '12px',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                cursor: submitting ? 'not-allowed' : 'pointer',
                transition: 'all 0.4s ease',
                fontWeight: 300,
                borderRadius: '4px',
                opacity: submitting ? 0.6 : 1
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting || !selectedReason}
              style={{
                flex: 1,
                padding: '10px 24px',
                background: submitting || !selectedReason ? '#553918' : '#312310',
                color: '#e6c57e',
                border: 'none',
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '12px',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                cursor: submitting || !selectedReason ? 'not-allowed' : 'pointer',
                transition: 'all 0.4s ease',
                fontWeight: 300,
                borderRadius: '4px',
                opacity: submitting || !selectedReason ? 0.6 : 1
              }}
            >
              {submitting ? 'Submitting...' : 'Submit Report'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Report User Modal Component
export const ReportUserModal = ({ user, onClose, onReport, currentUserId }) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    if (user) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [user]);

  if (!user) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedReason) {
      alert('Please select a reason for reporting');
      return;
    }

    setSubmitting(true);
    try {
      // Report type is 'user' - we're reporting the user account, not a specific photo
      // photoId should be null for user reports
      await onReport(null, currentUserId, user.id, selectedReason);
      onClose();
    } catch (error) {
      console.error('Report failed:', error);
      alert('Failed to submit report. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const reasons = [
    { value: 'nudity', label: 'Nudity' },
    { value: 'hate', label: 'Hate speech' },
    { value: 'violence', label: 'Violence' },
    { value: 'spam', label: 'Spam' },
    { value: 'other', label: 'Other' }
  ];

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(49,35,16,0.7)',
        zIndex: 10002,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        paddingTop: 'calc(20px + env(safe-area-inset-top))',
        paddingBottom: 'calc(20px + env(safe-area-inset-bottom))',
        paddingLeft: 'calc(20px + env(safe-area-inset-left))',
        paddingRight: 'calc(20px + env(safe-area-inset-right))'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: '#aeb4b8',
          padding: 'clamp(24px, 6vw, 40px)',
          maxWidth: '500px',
          width: 'calc(100% - 40px)',
          border: '1px solid rgba(130,85,30,0.2)',
          boxShadow: '0 8px 30px rgba(49,35,16,0.2)',
          borderRadius: '8px',
          boxSizing: 'border-box'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{
          fontFamily: "'Apple Garamond', Garamond, 'Times New Roman', serif",
          fontSize: 'clamp(1.4em, 4vw, 1.8em)',
          color: '#312310',
          letterSpacing: '0.08em',
          fontWeight: 400,
          marginBottom: '24px',
          textAlign: 'center',
          wordBreak: 'break-word',
          overflowWrap: 'break-word'
        }}>
          Report User
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '24px' }}>
            {reasons.map((reason) => (
              <label
                key={reason.value}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px',
                  marginBottom: '8px',
                  cursor: 'pointer',
                  borderRadius: '4px',
                  transition: 'background 0.2s ease',
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: 'clamp(12px, 3vw, 14px)',
                  color: '#312310',
                  minHeight: '44px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(130,85,30,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                <input
                  type="radio"
                  name="reportReason"
                  value={reason.value}
                  checked={selectedReason === reason.value}
                  onChange={(e) => setSelectedReason(e.target.value)}
                  style={{
                    marginRight: '12px',
                    width: '18px',
                    height: '18px',
                    cursor: 'pointer',
                    accentColor: '#af731f',
                    flexShrink: 0
                  }}
                />
                {reason.label}
              </label>
            ))}
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              style={{
                flex: 1,
                padding: 'clamp(10px, 2.5vw, 12px) clamp(16px, 4vw, 24px)',
                minHeight: '44px',
                background: '#553918',
                color: '#e6c57e',
                border: 'none',
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 'clamp(10px, 2.5vw, 12px)',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                cursor: submitting ? 'not-allowed' : 'pointer',
                transition: 'all 0.4s ease',
                fontWeight: 300,
                borderRadius: '4px',
                opacity: submitting ? 0.6 : 1,
                WebkitTapHighlightColor: 'transparent'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting || !selectedReason}
              style={{
                flex: 1,
                padding: 'clamp(10px, 2.5vw, 12px) clamp(16px, 4vw, 24px)',
                minHeight: '44px',
                background: submitting || !selectedReason ? '#553918' : '#312310',
                color: '#e6c57e',
                border: 'none',
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 'clamp(10px, 2.5vw, 12px)',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                cursor: submitting || !selectedReason ? 'not-allowed' : 'pointer',
                transition: 'all 0.4s ease',
                fontWeight: 300,
                borderRadius: '4px',
                opacity: submitting || !selectedReason ? 0.6 : 1,
                WebkitTapHighlightColor: 'transparent'
              }}
            >
              {submitting ? 'Submitting...' : 'Submit Report'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Block User Modal Component
export const BlockUserModal = ({ user, isBlocked, onClose, onBlock, onUnblock, currentUserId }) => {
  const [processing, setProcessing] = useState(false);

  React.useEffect(() => {
    if (user) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [user]);

  if (!user) return null;

  const handleConfirm = async () => {
    setProcessing(true);
    try {
      if (isBlocked) {
        await onUnblock(currentUserId, user.id);
      } else {
        await onBlock(currentUserId, user.id);
      }
      onClose();
    } catch (error) {
      console.error('Block/unblock failed:', error);
      alert('Operation failed. Please try again.');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(49,35,16,0.7)',
        zIndex: 10002,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        paddingTop: 'calc(20px + env(safe-area-inset-top))',
        paddingBottom: 'calc(20px + env(safe-area-inset-bottom))',
        paddingLeft: 'calc(20px + env(safe-area-inset-left))',
        paddingRight: 'calc(20px + env(safe-area-inset-right))'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: '#aeb4b8',
          padding: 'clamp(24px, 6vw, 40px)',
          maxWidth: '500px',
          width: 'calc(100% - 40px)',
          border: '1px solid rgba(130,85,30,0.2)',
          boxShadow: '0 8px 30px rgba(49,35,16,0.2)',
          borderRadius: '8px',
          boxSizing: 'border-box'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{
          fontFamily: "'Apple Garamond', Garamond, 'Times New Roman', serif",
          fontSize: 'clamp(1.4em, 4vw, 1.8em)',
          color: '#312310',
          letterSpacing: '0.08em',
          fontWeight: 400,
          marginBottom: '16px',
          textAlign: 'center',
          wordBreak: 'break-word',
          overflowWrap: 'break-word'
        }}>
          {isBlocked ? 'Unblock User' : 'Block User'}
        </h2>

        <p style={{
          fontFamily: "'Montserrat', sans-serif",
          fontSize: 'clamp(12px, 3vw, 14px)',
          color: '#553918',
          letterSpacing: '0.02em',
          lineHeight: 1.6,
          marginBottom: '24px',
          textAlign: 'center',
          wordBreak: 'break-word',
          overflowWrap: 'break-word'
        }}>
          {isBlocked 
            ? `Unblock @${user.username}? They will be able to see your profile and follow you again.`
            : `Block @${user.username}? They won't be able to follow you or see your profile.`
          }
        </p>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            type="button"
            onClick={onClose}
            disabled={processing}
            style={{
              flex: 1,
              padding: 'clamp(10px, 2.5vw, 12px) clamp(16px, 4vw, 24px)',
              minHeight: '44px',
              background: '#553918',
              color: '#e6c57e',
              border: 'none',
              fontFamily: "'Montserrat', sans-serif",
              fontSize: 'clamp(10px, 2.5vw, 12px)',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              cursor: processing ? 'not-allowed' : 'pointer',
              transition: 'all 0.4s ease',
              fontWeight: 300,
              borderRadius: '4px',
              opacity: processing ? 0.6 : 1,
              WebkitTapHighlightColor: 'transparent'
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={processing}
            style={{
              flex: 1,
              padding: 'clamp(10px, 2.5vw, 12px) clamp(16px, 4vw, 24px)',
              minHeight: '44px',
              background: processing ? '#553918' : '#312310',
              color: '#e6c57e',
              border: 'none',
              fontFamily: "'Montserrat', sans-serif",
              fontSize: 'clamp(10px, 2.5vw, 12px)',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              cursor: processing ? 'not-allowed' : 'pointer',
              transition: 'all 0.4s ease',
              fontWeight: 300,
              borderRadius: '4px',
              opacity: processing ? 0.6 : 1,
              WebkitTapHighlightColor: 'transparent'
            }}
          >
            {processing ? 'Processing...' : (isBlocked ? 'Unblock' : 'Block')}
          </button>
        </div>
      </div>
    </div>
  );
};


export const Lightbox = ({ photo, photos = [], currentIndex = 0, onClose, onDelete, canDelete, currentUserId, onReport, onNavigate }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fullImageLoaded, setFullImageLoaded] = useState(false);
  
  // Swipe state
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [swipeOffset, setSwipeOffset] = useState(0);
  const containerRef = useRef(null);

  const minSwipeDistance = 50;
  const hasMultiplePhotos = photos && photos.length > 1;
  const canGoNext = hasMultiplePhotos && currentIndex < photos.length - 1;
  const canGoPrev = hasMultiplePhotos && currentIndex > 0;

  useEffect(() => {
    if (photo) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [photo]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (showMenu && !e.target.closest('.lightbox-menu-container')) {
        setShowMenu(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showMenu]);

  useEffect(() => {
    if (photo && photo.url) {
      setFullImageLoaded(false);
      const img = new Image();
      img.onload = () => setFullImageLoaded(true);
      img.src = photo.url;
    }
  }, [photo]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight' && canGoNext) {
        handleNavigate(1);
      } else if (e.key === 'ArrowLeft' && canGoPrev) {
        handleNavigate(-1);
      } else if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex, photos, canGoNext, canGoPrev]);

  if (!photo) return null;

  const handleNavigate = (direction) => {
    const newIndex = currentIndex + direction;
    if (newIndex >= 0 && newIndex < photos.length && onNavigate) {
      onNavigate(newIndex);
    }
  };

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
    if (touchStart) {
      const distance = e.targetTouches[0].clientX - touchStart;
      // Only allow swipe in valid directions
      if ((distance > 0 && canGoPrev) || (distance < 0 && canGoNext)) {
        setSwipeOffset(distance * 0.5); // Dampen the movement
      }
    }
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) {
      setSwipeOffset(0);
      return;
    }
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe && canGoNext) {
      handleNavigate(1);
    } else if (isRightSwipe && canGoPrev) {
      handleNavigate(-1);
    }
    
    setSwipeOffset(0);
    setTouchStart(null);
    setTouchEnd(null);
  };

  const handleDelete = async () => {
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await onDelete(photo.id, photo.url);
      setShowDeleteModal(false);
      onClose();
    } catch (error) {
      console.error('Delete failed:', error);
      setShowDeleteModal(false);
    }
  };

  const handleReportClick = () => {
    setShowMenu(false);
    setShowReportModal(true);
  };

  const handleReport = async (photoId, reporterId, reportedUserId, reason) => {
    if (onReport) {
      await onReport(photoId, reporterId, reportedUserId, reason);
    }
  };

  const glassButtonStyle = {
    background: 'rgba(60, 60, 60, 0.6)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    color: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '50%',
    width: '44px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    outline: 'none',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    WebkitTapHighlightColor: 'transparent'
  };

  return (
    <>
      <div 
        ref={containerRef}
        style={{
          display: 'flex',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0, 0, 0, 0.85)',
          backdropFilter: 'blur(15px)',
          WebkitBackdropFilter: 'blur(15px)',
          zIndex: 10000,
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px',
          paddingTop: 'calc(40px + env(safe-area-inset-top))',
          paddingBottom: 'calc(40px + env(safe-area-inset-bottom))',
          opacity: 1,
          transition: 'opacity 0.4s ease',
          touchAction: 'pan-y pinch-zoom'
        }}
        onClick={onClose}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {/* Close Button */}
        <button 
          style={{
            ...glassButtonStyle,
            position: 'fixed',
            top: 'calc(20px + env(safe-area-inset-top))',
            right: 'calc(20px + env(safe-area-inset-right))',
            fontSize: '24px',
            fontWeight: 300,
            zIndex: 10001,
          }}
          onClick={onClose}
          onMouseEnter={(e) => e.target.style.background = 'rgba(80, 80, 80, 0.8)'}
          onMouseLeave={(e) => e.target.style.background = 'rgba(60, 60, 60, 0.6)'}
        >
          ×
        </button>

        {/* Navigation Arrows */}
        {canGoPrev && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleNavigate(-1);
            }}
            style={{
              ...glassButtonStyle,
              position: 'fixed',
              left: 'calc(20px + env(safe-area-inset-left))',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '24px',
              zIndex: 10001,
            }}
            onMouseEnter={(e) => e.target.style.background = 'rgba(80, 80, 80, 0.8)'}
            onMouseLeave={(e) => e.target.style.background = 'rgba(60, 60, 60, 0.6)'}
          >
            ‹
          </button>
        )}
        
        {canGoNext && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleNavigate(1);
            }}
            style={{
              ...glassButtonStyle,
              position: 'fixed',
              right: 'calc(20px + env(safe-area-inset-right))',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '24px',
              zIndex: 10001,
            }}
            onMouseEnter={(e) => e.target.style.background = 'rgba(80, 80, 80, 0.8)'}
            onMouseLeave={(e) => e.target.style.background = 'rgba(60, 60, 60, 0.6)'}
          >
            ›
          </button>
        )}
        
        {/* 3-dot menu button */}
        {!canDelete && currentUserId && photo.user_id !== currentUserId && (
          <div className="lightbox-menu-container" style={{
            position: 'fixed',
            top: 'calc(20px + env(safe-area-inset-top))',
            right: 'calc(75px + env(safe-area-inset-right))',
            zIndex: 10001
          }}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowMenu(!showMenu);
              }}
              style={{
                ...glassButtonStyle,
                fontSize: '20px',
                paddingBottom: '5px' 
              }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(80, 80, 80, 0.8)'}
              onMouseLeave={(e) => e.target.style.background = 'rgba(60, 60, 60, 0.6)'}
            >
              ⋮
            </button>
            
            {showMenu && (
              <div style={{
                position: 'absolute',
                top: '55px',
                right: 0,
                background: 'rgba(30, 30, 30, 0.85)',
                backdropFilter: 'blur(25px)',
                WebkitBackdropFilter: 'blur(25px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
                minWidth: '180px',
                overflow: 'hidden',
                animation: 'fadeIn 0.2s ease'
              }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleReportClick();
                  }}
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    background: 'transparent',
                    border: 'none',
                    color: '#ff453a', 
                    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
                    fontSize: '15px',
                    fontWeight: 500,
                    textAlign: 'left',
                    cursor: 'pointer',
                    transition: 'background 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
                  onMouseLeave={(e) => e.target.style.background = 'transparent'}
                >
                  Report Image
                </button>
              </div>
            )}
          </div>
        )}
        
        {canDelete && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
            style={{
              position: 'fixed',
              top: 'calc(20px + env(safe-area-inset-top))',
              right: 'calc(75px + env(safe-area-inset-right))',
              padding: '0 20px',
              height: '44px',
              background: 'rgba(60, 60, 60, 0.6)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '22px',
              color: '#ff453a',
              fontSize: '15px',
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
              transition: 'all 0.3s ease',
              zIndex: 10001,
              WebkitTapHighlightColor: 'transparent'
            }}
            onMouseEnter={(e) => e.target.style.background = 'rgba(80, 80, 80, 0.8)'}
            onMouseLeave={(e) => e.target.style.background = 'rgba(60, 60, 60, 0.6)'}
          >
            Delete
          </button>
        )}

        {/* Photo counter */}
        {hasMultiplePhotos && (
          <div style={{
            position: 'fixed',
            bottom: 'calc(20px + env(safe-area-inset-bottom))',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '8px 16px',
            background: 'rgba(40, 40, 40, 0.8)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '20px',
            color: 'rgba(255, 255, 255, 0.9)',
            fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
            fontSize: '13px',
            fontWeight: 500,
            zIndex: 10001,
            pointerEvents: 'none'
          }}>
            {currentIndex + 1} / {photos.length}
          </div>
        )}

        <div style={{
          position: 'relative',
          maxWidth: '90%',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'lightboxZoom 0.4s cubic-bezier(0.19, 1, 0.22, 1)',
          transform: `translateX(${swipeOffset}px)`,
          transition: swipeOffset === 0 ? 'transform 0.3s cubic-bezier(0.19, 1, 0.22, 1)' : 'none',
        }}>
          <img 
            src={fullImageLoaded ? photo.url : (photo.feed_url || photo.url)} 
            alt="Full size" 
            style={{
              maxWidth: '100%',
              maxHeight: (photo.caption && photo.caption.trim()) ? '75vh' : '85vh',
              objectFit: 'contain',
              borderRadius: '4px',
              boxShadow: '0 40px 80px rgba(0,0,0,0.5)', 
              opacity: fullImageLoaded ? 1 : 0.9,
              transition: 'opacity 0.3s ease',
              userSelect: 'none',
              pointerEvents: 'none'
            }}
            onClick={(e) => e.stopPropagation()}
          />
          
          {photo.caption && photo.caption.trim() && (
            <div 
              style={{
                marginTop: '12px',
                padding: '16px 24px',
                maxWidth: '600px',
                width: 'auto',
                background: 'rgba(40, 40, 40, 0.65)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <p style={{
                fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
                fontSize: '15px',
                fontWeight: 400,
                color: 'rgba(255, 255, 255, 0.9)',
                letterSpacing: '-0.01em',
                lineHeight: 1.5,
                margin: 0,
                textAlign: 'center',
                wordBreak: 'break-word',
                overflowWrap: 'break-word'
              }}>
                {photo.caption}
              </p>
            </div>
          )}
        </div>
      </div>
      
      {showReportModal && (
        <ReportImageModal
          photo={photo}
          onClose={() => setShowReportModal(false)}
          onReport={handleReport}
          currentUserId={currentUserId}
        />
      )}

      {showDeleteModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.4)', 
            backdropFilter: 'blur(5px)',
            WebkitBackdropFilter: 'blur(5px)',
            zIndex: 20000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px'
          }}
          onClick={() => setShowDeleteModal(false)}
        >
          <div
            style={{
              background: 'rgba(30, 30, 30, 0.85)',
              backdropFilter: 'blur(40px)',
              WebkitBackdropFilter: 'blur(40px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '18px',
              padding: '24px',
              maxWidth: '300px',
              width: '100%',
              boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
              transform: 'scale(1)',
              animation: 'popIn 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '17px',
                fontWeight: 600,
                color: 'white',
                marginBottom: '8px',
                textAlign: 'center',
              }}
            >
              Delete Photo?
            </div>
            <div
               style={{
                fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '13px',
                fontWeight: 400,
                color: 'rgba(255, 255, 255, 0.6)',
                marginBottom: '24px',
                textAlign: 'center',
              }}
            >
              This action cannot be undone.
            </div>
            
            <div
              style={{
                display: 'flex',
                gap: '12px',
                justifyContent: 'space-between'
              }}
            >
              <button
                onClick={() => setShowDeleteModal(false)}
                style={{
                  flex: 1,
                  padding: '12px 0',
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: 'none',
                  color: 'white',
                  fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
                  fontSize: '15px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  borderRadius: '10px',
                  transition: 'background 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.15)'}
                onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                style={{
                  flex: 1,
                  padding: '12px 0',
                  background: '#ff453a', 
                  border: 'none',
                  color: 'white',
                  fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
                  fontSize: '15px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  borderRadius: '10px',
                  transition: 'opacity 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.9'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <style>{`
        @keyframes lightboxZoom {
          from { opacity: 0; transform: scale(0.98); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes popIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </>
  );
};


// Gallery Component
export const Gallery = ({ photos, onDelete, canDelete, showUsername = false, currentUserId, onReport, onUsernameClick }) => {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  if (!photos.length) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '60px',
        color: '#82551e',
        fontSize: '0.85em',
        letterSpacing: '0.15em',
        textTransform: 'uppercase',
        fontWeight: 300
      }}>
        No images yet
      </div>
    );
  }

  return (
    <>
      <div className="gallery">
        {photos.map((photo, index) => (
          <div 
            key={photo.id || index}
            className="gallery-item"
            style={{ animationDelay: `${index * 0.03}s`, position: 'relative' }}
            onClick={() => setLightboxIndex(index)}
          >
            <div className="image-wrapper">
              <LazyImage
                src={photo.feed_url || photo.url}
                alt=""
              />
              {showUsername && photo.username && (
                <div 
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onUsernameClick) {
                      onUsernameClick(photo.username, photo.user_id);
                    }
                  }}
                  style={{
                    position: 'absolute',
                    bottom: '10px',
                    left: '10px',
                    background: 'rgba(49,35,16,0.8)',
                    color: '#e6c57e',
                    padding: '6px 12px',
                    borderRadius: '4px',
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: '0.75em',
                    letterSpacing: '0.05em',
                    fontWeight: 300,
                    cursor: onUsernameClick ? 'pointer' : 'default',
                    zIndex: 2,
                    transition: onUsernameClick ? 'all 0.2s ease' : 'none'
                  }}
                  onMouseEnter={(e) => {
                    if (onUsernameClick) {
                      e.currentTarget.style.background = 'rgba(175,115,31,0.9)';
                      e.currentTarget.style.transform = 'scale(1.05)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (onUsernameClick) {
                      e.currentTarget.style.background = 'rgba(49,35,16,0.8)';
                      e.currentTarget.style.transform = 'scale(1)';
                    }
                  }}
                >
                  @{photo.username}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <Lightbox 
        photo={lightboxIndex !== null ? photos[lightboxIndex] : null}
        photos={photos}
        currentIndex={lightboxIndex}
        onNavigate={(newIndex) => setLightboxIndex(newIndex)}
        onClose={() => setLightboxIndex(null)}
        onDelete={onDelete}
        canDelete={canDelete}
        currentUserId={currentUserId}
        onReport={onReport}
      />
    </>
  );
};


/**Gallery Component
  └─> Click image
      └─> Opens Lightbox
          ├─> Click × → Close
          ├─> Click Delete (if owner) → Delete Confirmation Modal → onDelete()
          └─> Click ⋮ menu (if not owner) → "Report Image"
              └─> Opens ReportImageModal → onReport() */